// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1HLkq","titleWrap":"style_titleWrap__1bsoN","actionsDropdownWrapper":"style_actionsDropdownWrapper__23i0g"};